// ═══════════════════════════════════════════════════════
// PAGE TRANSITION — Fade-in wrapper for page content
// Aplicado automaticamente ao navegar entre páginas.
// ═══════════════════════════════════════════════════════
import { useState, useEffect, type ReactNode } from "react";

interface PageTransitionProps {
  pageKey: string;
  children?: ReactNode;
}

export default function PageTransition({ pageKey, children }: PageTransitionProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(false);
    // Double rAF to ensure the opacity:0 frame is painted before transition
    const t = requestAnimationFrame(() => {
      requestAnimationFrame(() => setVisible(true));
    });
    return () => cancelAnimationFrame(t);
  }, [pageKey]);

  return (
    <div
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(8px)",
        transition: "opacity 0.25s ease, transform 0.25s ease",
      }}
    >
      {children}
    </div>
  );
}
